import React, { useContext } from 'react'
import { getCategoryJp } from '../../utils/news'
import { style } from './PageTitle.style'
import Content from '../Content/Content'
import { CategoryContext } from './CategoryContext'

const PageTitle = () => {
  const category = useContext(CategoryContext)
  return (
    <Content>
      <header css={style.header(category)}>
        <h1>
          <span>{getCategoryJp(category)}大学サイト</span>
        </h1>
      </header>
    </Content>
  )
}

export default PageTitle
